<script>
import compoment from '@/components/draggable/VipDefaultComponents/DVipEditor'
export default {
  name: 'DRealnameEditor',
  extends: compoment
}
</script>
